import Container from './BookmarksListMobile.container';
import BookmarksListMobile from './BookmarksListMobile';

export default Container(BookmarksListMobile);
